<template>
  <div class="w-100">
    <flickity ref="flickity"
        :options="flickityOptionsCard" class="slider-card">
        <div class="carousel-cell w-100 mr-3 mb-3 bg-card-height slider-card" v-for="data in member_card" @click="onBack('onScroll',data.type)">
          <div class="w-100 py-3 px-4 border bg-card bg-card-height position-absolute" style="z-index: 9" :style="{backgroundColor: data.color}">
            <div class="row no-gutters">
              <div class="col-2">
                <img src="../../../../assets/img/hotel/logo_white.png" width="50">
              </div>
              <div class="col-8">
                <p class="mb-0 font-extrabold ls-0-5 text-white text-22 ml_10px">Kubu Tropis</p>
              </div>
            </div>
            <div class="position-relative top_card_body">
              <p class="mb-0 font-bold ls-0-5 text-24 text-white">Shamanta</p>
              <div class="row no-gutters">
                <div class="col-6">
                  <p class="mb-0 font-regular ls-0-5 text-14 text-white">ID 8792-9120</p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 font-extrabold ls-0-5 text-16 text-white">{{data.type}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-80 mr-3 mb-3 border bg-card bg-card-height position-absolute box-shadow-main card-left" style="top:8px;opacity: 55%;z-index: 8" :style="{backgroundColor: data.color}">
          </div>
        </div>  
      </flickity>
  </div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from "vuex";

  export default{
    components: {
      Flickity,
    },
    data() {
      return {
        flickityOptionsCard: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: true,
          cellAlign: "left",
          draggable: true,
          wrapAround: true,
        },
        member_card: [
          {
            id: 1,
            type: "Green Card",
            color: "#79a33a",
          },        
          {
            id: 2,
            type: "Premium",
            color: "#283080",
          },
          {
            id: 3,
            type: "Titanium",
            color: "#2a2b3c",
          },
          {
            id: 4,
            type: "Silver",
            color: "#b7b7b7",
          }
        ],
      }
    },
    computed: {
     
    },
    watch:{
      
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
    },
    methods: {
      ...mapGetters(['getMerchant']),
      onBack(type, data){
        this.$emit(type, data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/hotel/concierge/member/MemberCardSlide.vue